<div class="flex h-dvh w-full overflow-hidden">
  <app-sidebar></app-sidebar>
  <div class="relative flex grow flex-col content-start overflow-hidden">
    @if (!hideTopBar()) {
      <app-top-bar></app-top-bar>
    }
    <div class="grow overflow-auto bg-slate-100 relative">
      <router-outlet />
    </div>
    @if (layoutService.mobileNavOpen()) {
      <button
        type="button"
        class="absolute inset-0 z-40 cursor-pointer border-0 bg-black/40 lg:hidden"
        aria-label="Close menu"
        (click)="closeMobileNav()"></button>
    }
  </div>
</div>
